import SoldItem from './SoldItem'
import { Container, SubTitle, LabelRow } from './styles'

export default function SoldItemList ({ items = [] }) {
  return (
    <Container>
      <LabelRow>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Qtd. vendida</SubTitle>
      </LabelRow>
      {items.map ((item, index) => (
        <SoldItem key={index} data={item}/>
      ))}
    </Container>
  )
}
